import type { VoidFunctionComponent } from 'react';

import { BaseLayerExclusionFields } from '../../../shared/settings/BaseLayerExclusionFields';
import Section from '../../../shared/settings/SettingsPageSection';

import type { ContainerSettingsProps } from './types';

/**
 * ProjectContainerIssuesSettings
 *
 * Container base-layer issue settings for a project. Lets a user exclude
 * issues that originate from a container's base layer, per category.
 *
 * These are saved with the rest of the issue policies when the page-level
 * Save button is clicked.
 */
export const ProjectContainerIssuesSettings: VoidFunctionComponent<ContainerSettingsProps> = ({
  excludeLicensingIssues,
  onToggleExcludeLicensingIssues,
  excludeSecurityIssues,
  onToggleExcludeSecurityIssues,
  excludeQualityIssues,
  onToggleExcludeQualityIssues,
  isDisabled,
}) => (
  <Section>
    <Section.Left heading="Containers">
      <Section.Paragraph>
        Configuration for container-based scans on this project.
      </Section.Paragraph>
    </Section.Left>
    <Section.Right>
      <BaseLayerExclusionFields
        excludeLicensingIssues={excludeLicensingIssues}
        onToggleExcludeLicensingIssues={onToggleExcludeLicensingIssues}
        excludeSecurityIssues={excludeSecurityIssues}
        onToggleExcludeSecurityIssues={onToggleExcludeSecurityIssues}
        excludeQualityIssues={excludeQualityIssues}
        onToggleExcludeQualityIssues={onToggleExcludeQualityIssues}
        isDisabled={isDisabled}
      />
    </Section.Right>
  </Section>
);
